export class PeerReviewInProgressMigrationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PeerReviewInProgressMigrationError';
  }
}
